/*
 * DRVN — make product card images link through to the product page.
 *
 * The Collection Grid section only wraps the whole card in a link when the
 * "View Product" button is turned OFF. We keep the button on, so the image
 * itself carries no link. This adds a real anchor around the image area.
 *
 * The images are a multi-image swipe carousel with mouse-drag handlers, so a
 * naive link would fire navigation on every swipe. Anything that travels more
 * than DRAG_TOLERANCE pixels is treated as a drag and does not navigate.
 */
(function () {
  var DRAG_TOLERANCE = 8;

  function guard(link) {
    var startX = 0;
    var startY = 0;
    var dragged = false;

    function down(x, y) {
      startX = x;
      startY = y;
      dragged = false;
    }

    function move(x, y) {
      if (Math.abs(x - startX) > DRAG_TOLERANCE || Math.abs(y - startY) > DRAG_TOLERANCE) {
        dragged = true;
      }
    }

    link.addEventListener('mousedown', function (e) {
      down(e.clientX, e.clientY);
    });

    link.addEventListener('mousemove', function (e) {
      if (e.buttons === 1) move(e.clientX, e.clientY);
    });

    link.addEventListener('touchstart', function (e) {
      down(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }, { passive: true });

    link.addEventListener('touchmove', function (e) {
      move(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }, { passive: true });

    link.addEventListener('click', function (e) {
      if (dragged) {
        e.preventDefault();
        dragged = false;
      }
    });
  }

  function init() {
    var links = document.querySelectorAll('.product-image-link');
    for (var i = 0; i < links.length; i++) {
      if (links[i].dataset.drvnGuarded) continue;
      links[i].dataset.drvnGuarded = '1';
      guard(links[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
